<template>
	<div class="summary-wrapper">
		<div class="summary-title">
			<h4 class="winery-title d-inline">{{ selectedWinery.title }}</h4>
			<p class=" ml-1 d-inline">{{ selectedWinery.region.title }}, {{ selectedWinery.land.title }}</p>
		</div>
		<LoadingAnimation v-if="loading" />
		<div class="wines-container" v-if="loading == false">
			<b-row class="table-head-summary">
				<div class="col-number">
					<p>{{ $t('winelist.addWineModal.number_short') }}</p>
				</div>

				<div class="col-title" style="flex-grow: 2">
					<p>{{ $t('general.name') }}</p>
				</div>
				<div class="col-grape-variety" style="flex-grow: 2">
					<p>{{ $t('general.grapeVariety') }}</p>
				</div>
				<div class="col-selected-year">
					<p>{{ $t('general.year') }}</p>
				</div>
				<div class="col-selected-bottlesize">
					<p>{{ $t('general.size') }}</p>
				</div>
				<div class="col-wine-amount">
					<p>{{ $t('general.amount_new') }}</p>
				</div>
				<div class="col-selected-wine-supplier">
					<p>{{ $t('general.supplier') }}</p>
				</div>
				<div class="col-shelf">
					<p>{{ $t('general.shelf') }}</p>
				</div>
				<div class="col-ek">
					<p>{{ $t('general.ekNet') }} {{ getCurrency }}</p>
				</div>
				<div class="col-vk">
					<p>{{ $t('general.vkGross') }} {{ getCurrency }}</p>
				</div>
				<div class="col-weq">
					<p>{{ $t('general.weq') }}</p>
				</div>
			</b-row>
			<b-row class="wine-row uploadable-wines" v-for="(wine, index) in uploadableWines" :key="index"
				:class="{ error: wine.alert.alertIsVisible }">
				<div class="col-number">
					<p>{{ index + 1 }}</p>
				</div>
				<div class="col-title" style="flex-grow: 2">
					<p>{{ wine.title }}</p>
				</div>
				<div class="col-grape-variety" style="flex-grow: 2">
					<p>{{ limitString(18, wine.grapeVariety.title) }}</p>
				</div>
				<div class="col-selected-year">
					<p>{{ showYearValue(wine) }}</p>
				</div>
				<div class="col-selected-bottlesize">
					<p>{{ wine.selectedBottlesize.attributes.amount }} {{ $t('general.liter_short') }}</p>
				</div>
				<div class="col-wine-amount">
					<p>{{ wine.wineAmountFloat }}</p>
				</div>
				<div class="col-selected-wine-supplier">
					<p>{{ limitString(21, wine.selectedWineSupplier.title) }}</p>
				</div>
				<div class="col-shelf">
					<p>{{ wine.shelf }}</p>
				</div>
				<div class="col-ek">
					<p>{{ parseFloat(wine.ek).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
				</div>
				<div class="col-vk">
					<p>{{ parseFloat(wine.vk).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
				</div>
				<div class="col-weq">
					<Weq :purchasePriceAvg="wine.ek" :sellingPrice="wine.vk" />
				</div>
				<b-alert fade variant="danger" :show="wine.alert.alertIsVisible">
					{{ wine.alert.alertMessage }}
				</b-alert>
			</b-row>

		</div>
	</div>
</template>

<script>
import LoadingAnimation from '@/components/LoadingAnimation.vue'
import DataMappingService from '@/services/DataMappingService'
import * as Utils from '@/utils/functions'
import { mapGetters } from 'vuex'
import DataService from '@/services/StrapiService'
import { applyMandatoryRatingAgencies, addSupplierAndPrice } from '@/utils/venueWineFunctions'
import { limitString } from '@/utils/functions'

import Weq from '@/components/wineDetail/Weq.vue';

export default {
	name: 'Summary',
	components: {
		Weq,
		LoadingAnimation,

	},
	props: {
		selectedWines: {
			type: Array,
			required: true
		},
		selectedWinery: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			uploadableWines: this.selectedWines,
			loading: false,
		}
	},
	mounted() {
	},
	methods: {
		limitString,
		resetAlert() {
			for (const wine of this.uploadableWines) {
				wine.alert = {
					alertIsVisible: false,
					alertMessage: ''
				}
			}
		},
		showAlertInWineRow(responseWineId, responseBottleSizeId, message) {
			const index = this.uploadableWines.findIndex(wine => wine.id === responseWineId && wine.selectedBottlesize.id === responseBottleSizeId)
			this.uploadableWines[index].alert = {
				alertIsVisible: true,
				alertMessage: message,
			}
			this.updateValues(index)
		},
		updateValues(index) {
			this.$set(this.uploadableWines, index, this.uploadableWines[index])
		},
		showLoading() {
			this.loading = true
		},
		hideLoading() {
			this.loading = false
		},
    showYearValue(wine) {
      if (wine.selectedYear === 0) {
        return this.$t('general.notDefined')
      } else {
        return wine.selectedYear
      }
    },
		async saveWines() {
			this.showLoading();
			let successfulSaves = 0;
			const venueWineIds = [];

			// Create an array of promises, one for each wine to be saved.
			const savePromises = this.uploadableWines.map(wine => {
				let venueWineObject = {
					attributes: {
						title: wine.title.trim(),
						venue: this.getVenue.id,
						bottleSize: wine.selectedBottlesize.id,
						year: wine.selectedYear,
						wine: wine.id,
						ratings: [],
						sellingPrice: wine.vk,
						amountFloat: wine.wineAmountFloat,
						shelfNumber: wine.shelf,
						isDuplicate: wine.isDuplicate,
					}
				};
				applyMandatoryRatingAgencies(venueWineObject, this.getRatingAgencies);
				venueWineObject = addSupplierAndPrice(venueWineObject, wine.ek, wine.selectedWineSupplier, wine.wineAmountFloat);
				
				// Return the promise from the DataService
        
            //do what you need here
        return DataService.createVenueWine(venueWineObject);
        
			});

			try {
				// Use Promise.allSettled to wait for all promises to resolve or reject.
				const results = await Promise.allSettled(savePromises);

				// Now process the results
				results.forEach((result, index) => {
					const originalWine = this.uploadableWines[index];

					if (result.status === 'fulfilled') {
						const createVenueWineResponse = result.value;
						const mappedResponse = DataMappingService.mapVenueWineApiToVenueWineUi(createVenueWineResponse);
						
						if (createVenueWineResponse.status === 200) {
							successfulSaves++;
							venueWineIds.push(mappedResponse.id);
						} else {
							// The API returned an error status (e.g., 400, 500)
							this.showAlertInWineRow(originalWine.id, originalWine.selectedBottlesize.id, this.$t('errors.dataNotValid'));
						}
					} else {
						// The promise was rejected (e.g., network error, CORS issue)
						console.error('Failed to save wine:', result.reason);
						this.showAlertInWineRow(originalWine.id, originalWine.selectedBottlesize.id, this.$t('errors.networkError')); // Assuming you have a 'networkError' translation
					}
				});

			} catch (error) {
				// This catch block is for catastrophic errors with Promise.allSettled itself, which is unlikely.
				console.error("An unexpected error occurred during the save process:", error);
			} finally {
				// This will run after all promises are settled.
				this.hideLoading();

				// Show a more informative success/failure message
				const totalWines = this.uploadableWines.length;
				let alertobject;
				if (successfulSaves === totalWines) {
					// All wines saved successfully → clear the draft
					Utils.clearAddWineDraft()
					alertobject = {
						text: this.$t('winelist.addWineModal.addedWines'), // "All wines added successfully"
						variant: 'success'
					};
				} else {
					alertobject = {
						text: `${successfulSaves} ${this.$t('general.of')} ${totalWines} ${this.$t('general.wines_plural')} ${this.$t('general.added_successfully')}.`, // e.g., "5 of 7 wines added successfully."
						variant: successfulSaves > 0 ? 'warning' : 'danger'
					};
				}
				this.$store.commit('setAlertText', alertobject);
			}

			return venueWineIds;
		},
	},
	computed: {
		getCurrency() {
			return Utils.getVenueCurrency(this.getVenue);
		},
		...mapGetters(['getVenue', 'getRatingAgencies'])

	}
}
</script>
<style scoped>
.wines-container p,
.wines-container span

/* for WEQ */
	{
	color: var(--color-gray-100) !important;
	font-size: var(--font-xs);
	font-weight: normal;
}

.error p,
.error span {
	color: var(--color-danger) !important;
}

.row {
	min-height: 40px;
}

.table-head-summary p {
	font-weight: 700;
}

h4.winery-title {
	margin-right: var(--margin-xs);
}

.summary-title {
	margin-bottom: var(--margin-m);
}


.col-number {
	width: 28px !important;
}

.col-title {
	width: 270px !important;
}

.col-grape-variety {
	width: 108px !important;
}

.col-selected-year {
	width: 50px !important;
}

.col-selected-bottlesize {
	width: 60px !important;
}

.col-wine-amount {
	width: 60px !important;
}

.col-selected-wine-supplier {
	width: 140px !important;
}

.col-shelf {
	width: 48px !important;
}

.col-ek {
	width: 90px !important;
}

.col-vk {
	width: 90px !important;
}

.col-weq {
	width: 60px !important;
}
</style>